import _ from 'lodash';
import * as diffUtils from './diffUtils';

const TEAMS_CHANGE_FIELDS = {
  'EndringsStatus': 'Uendret',
  'GruppeEndringsStatus': 'Uendret',
  'Tidligere_GruppeNavn': '#N/A',
  'Tidligere_GruppeKategori': '#N/A',
  'Tidligere_AktivPaamelding': '#N/A',
  'Tidligere_AntallMedlemmer': '#N/A',
};

/*
* Team Members
*/
export function changesToTeams(detailsDiff, previousData) {
  let result = [];
  _.forEach(detailsDiff, (value, key) => {
    let changed_object = null;
    if (diffUtils.isNew(value)) {
      changed_object = addNewTeam(value);
    } else if (diffUtils.isDeleted(value)) {
      changed_object = addDeletedTeam(value);
    } else if (diffUtils.hasChanged(value)) {
      let item = previousData[Number(key)];
      changed_object = addTeamChanges(item, value);
    } else {
      return;
    }
    result.push(changed_object);
  });
  return result;
}

export function addDeletedTeam(changes) {
  return {
    ...changes[0],
    ...TEAMS_CHANGE_FIELDS,
    EndringsStatus: 'Endret',
    GruppeEndringsStatus: 'Slettet'
  };
}

export function addNewTeam(changes) {
  return {
    ...changes[0],
    ...TEAMS_CHANGE_FIELDS,
    EndringsStatus: 'Endret',
    GruppeEndringsStatus: 'Ny'
  };
}

function updateTeam(item, changes) {
  _.forEach(changes, (change, key) => {
    if (['GruppeNavn', 'GruppeKategori', 'AktivPaamelding', 'AntallMedlemmer'].indexOf(key) > -1) {
      item['GruppeEndringsStatus'] = 'Endret';
      item['Tidligere_' + key] = item[key];
      item[key] = change[0];
    }
  });
  return item;
}

export function addTeamChanges(item, changes) {
  if (!item) {
    return;
  }
  let result = {
    ...item,
    ...TEAMS_CHANGE_FIELDS,
    EndringsStatus: 'Endret'
  };
  result = updateTeam(result, changes);
  return result;
}

/*
* Team Members
*/
const TEAM_MEMBERS_CHANGE_FIELDS = {
  'EndringsStatus': 'Uendret',
  'GruppeEndringsStatus': 'Uendret',
  'MedlemsEndringsStatus': 'Uendret',
  'Tidligere_MedlemsKategorier': '#N/A',
  'Tidligere_GruppeNavn': '#N/A',
  'Tidligere_GruppeKategori': '#N/A',
  'Tidligere_AktivPaamelding': '#N/A',
};

export const CROSS_TEAM_MEMBERS_CHANGE_FIELDS = {
  'EndringsStatus': 'Uendret',
  'GruppeEndringsStatus': 'Uendret',
  'MedlemsEndringsStatus': 'Uendret',
  'Tidligere_MedlemsKategorier': '#N/A',
  'Tidligere_GruppeNavn': '#N/A',
  'Tidligere_GruppeKategori': '#N/A',
  'Tidligere_AktivPaamelding': '#N/A',
  'Tidligere_KryssGruppeNavn': '#N/A',
  'Tidligere_KryssGruppeKategori': '#N/A',
  'Tidligere_KryssMedlemsKategorier': '#N/A',
};

export function changesToTeamMembers(detailsDiff, previousData, changeFields=TEAM_MEMBERS_CHANGE_FIELDS) {
  let result = [];
  _.forEach(detailsDiff, (value, key) => {
    let changed_object = null;
    if (diffUtils.isNew(value)) {
      changed_object = addNewTeamMember(value, changeFields);
    } else if (diffUtils.isDeleted(value)) {
      changed_object = addDeletedTeamMember(value, changeFields);
    } else if (diffUtils.hasChanged(value)) {
      changed_object = addTeamMemberChanges(previousData[Number(key)], value, changeFields);
    } else {
      return;
    }
    result.push(changed_object);
  });
  return result;
}

export function addDeletedTeamMember(changes, changeFields) {
  return {
    ...changes[0],
    ...changeFields,
    'EndringsStatus': 'Endret',
    'MedlemsEndringsStatus': 'Slettet'
  };
}

export function addNewTeamMember(changes, changeFields) {
  return {
    ...changes[0],
    ...changeFields,
    EndringsStatus: 'Endret',
    MedlemsEndringsStatus: 'Ny'
  };
}

function updateTeamMember(item, changes) {
  let groupChangeFields = ['GruppeNavn',
    'GruppeKategori',
    'AktivPaamelding',
    'AntallMedlemmer',
    'KryssGruppeNavn',
    'KryssGruppeKategori',
  ]
  _.forEach(changes, (change, key) => {
    if (groupChangeFields.indexOf(key) > -1) {
      item['GruppeEndringsStatus'] = 'Endret';
    } else if(key == 'MedlemsKategorier' || key == 'KryssMedlemsKategorier') {
      item['MedlemsEndringsStatus'] = 'Endret';
    }
    item['Tidligere_' + key] = item[key];
    item[key] = change[0];
  });
  return item;
}

export function addTeamMemberChanges(item, changes, changeFields) {
  let result = {
    ...item,
    ...changeFields,
    EndringsStatus: 'Endret'
  };
  result = updateTeamMember(result, changes);
  return result;
}



/** WEBPACK FOOTER **
 ** ./src/containers/events/reports/sql/teamDiffUtils.js
 **/